


















































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { UserQuestionListForm } from '../../../api/v2/forms/user_question'
import UserQuestion from '../../../api/v2/models/user_question'
import Pagination from '../../models/pagination'
import Question from '../../models/question'
import { userQuestionState } from '../../stores/user_quetions'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import {makeChannel, removeChannel} from '../../../../action_cable/cable'
@Component({
  components: {
    Simplemde
  }
})
export default class UserQuestionList extends Vue {
  @Prop({ default: '' }) relativeableType: 'Lesson' | 'Course' | ''
  @Prop({ default: 0 }) relativeableId: number
  @Prop({ required: false }) onClickQuestion: (question: UserQuestion) => void
  questions: UserQuestion[] = []
  pagination: Pagination
  chanel: any = null
  isLoading: boolean = true
  userQuestionListForm: UserQuestionListForm

  created() {
    this.userQuestionListForm = new UserQuestionListForm()
    this.getList()
    this.createChannel()
  }

  mounted() {
    this.$root.$on('questionCreated', this.getList)
  }

  async selectPage(page: number) {
    this.userQuestionListForm.page = page
    await this.getList()
  }

  onQuestionClick(question: UserQuestion){
    if (this.onClickQuestion) {
      this.onClickQuestion(question)
    } else {
      window.open(`/classroom/questions/${question.id}`, '_blank');
    }
  }

  async getList() {
    if (this.relativeableType) {
      this.userQuestionListForm.relativeableType = this.relativeableType
      this.userQuestionListForm.relativeableId = this.relativeableId
    }

    try {
      [this.pagination, this.questions] = await userQuestionState.fetchList(this.userQuestionListForm)
    } catch (e) {
    } finally {
      this.isLoading = false
    }
  }

  createChannel() {
    removeChannel('LessonQuestionChannel')
    this.chanel = makeChannel(
      'LessonQuestionChannel',
      async (e) => {
        this.getList()
      },
      () => {
        this.chanel.send({
          action: 'follow',
          data: {
            relativeable_id: this.relativeableId,
            relativeable_type: this.relativeableType
          }
        })
      },
    )
  }

  @Watch('relativeableId')
  onChangeRelativeableId(){
    this.getList()
    this.createChannel()
  }
}
